<!--<app-inline-dialog-title>Story preview</app-inline-dialog-title>-->

<app-images-slider [images]="imageUrls()">
  <app-icons
    [isLiked]="storyReactions()?.heart?.userHasReacted"
    [heartCounter]="storyReactions()?.heart?.count"
    [chatCounter]="storyReactions()?.comments?.count"
    [isPreviewMode]="isPreviewMode()"
    class="w-[100px] h-full"></app-icons>
</app-images-slider>

<app-divider class="mb-8"></app-divider>
<p class="text-gray">{{ date() }}</p>
<div>
  <div class="story-title">
    <p class="font-bold text-2xl my-4 inline-flex mr-2">{{ story().title }}</p>
  </div>
  @if (audioUrl()) {
    <p class="text-gray">Listen to this story</p>
    <app-voice-recording [audioUrl]="audioUrl()" [isPreviewMode]="true" class="mb-4 block "></app-voice-recording>
  }
</div>

<p class="story-content" [innerHTML]="story().content"></p>
<app-facet-pills [isPreviewMode]="isPreviewMode()" [facets]="facetTypes()"></app-facet-pills>

<p class="font-bold text-lg mt-8 mb-4">Share your story with:</p>
<div class="flex gap-4 mb-4">
  <div class="flex basis-1/3" (click)="shareStoryWith()">
    <app-card-item class="cursor-pointer rounded-xl" icon="heroUserCircle" [isChevronIcon]="true">
      <ng-container title>
        Friends
      </ng-container>
      <ng-container subtitle>
        For your friends only
      </ng-container>
    </app-card-item>
  </div>
  <app-tooltip class="flex basis-1/3">
    <app-card-item class="cursor-pointer rounded-xl" icon="heroGlobeAlt" [isChevronIcon]="true">
      <ng-container title>
        Communities
      </ng-container>
      <ng-container subtitle>
        Select communities
      </ng-container>
    </app-card-item>
    <ng-container tooltip>Comming soon</ng-container>
  </app-tooltip>
</div>

